import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Radio } from "lucide-react";
import { LiveBoard } from "../components/LiveBoard";

const TITLE = "Live Cashback & Lucky Draw Winners | Paras CashBack";
const DESC = "See real-time cashback rewards and lucky-draw winners on Paras CashBack. Transparent, privacy-masked proof of rewards paid to customers.";

export default function LiveBoardPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const prev = document.title; document.title = TITLE;
    const m = document.querySelector('meta[name="description"]');
    const pd = m ? m.getAttribute("content") : null;
    if (m) m.setAttribute("content", DESC);
    return () => { document.title = prev; if (m && pd) m.setAttribute("content", pd); };
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100" data-testid="live-board-page">
      <div className="mx-auto max-w-5xl px-5 py-10">
        <button onClick={() => navigate("/")} className="mb-8 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-emerald-400" data-testid="live-back">
          <ArrowLeft className="h-4 w-4" /> Back to Paras CashBack
        </button>
        <div className="mb-8 flex items-center gap-3">
          <div className="rounded-2xl bg-emerald-500/15 p-3"><Radio className="h-6 w-6 text-emerald-400" /></div>
          <div>
            <h1 className="font-heading text-3xl font-extrabold sm:text-4xl">Live Rewards Board</h1>
            <p className="text-sm text-slate-400">Real proof of cashback and lucky-draw prizes paid to Paras customers.</p>
          </div>
        </div>
        <LiveBoard />
        <div className="mt-10 flex justify-center">
          <button onClick={() => navigate("/login")} className="rounded-full bg-emerald-500 px-6 py-2.5 font-semibold text-slate-950 hover:bg-emerald-400" data-testid="live-cta-login">Start earning cashback</button>
        </div>
      </div>
    </div>
  );
}
